import { putJson } from "../../../../core/utils/http";

type cambiarClaveHandler = (claveActual: string, nuevaClave: string) => Promise<void>;

export const cambiarClave: cambiarClaveHandler = (claveActual: string, nuevaClave: string) =>
	putJson("/Usuarios/clave", { claveActual, nuevaClave });